import { getRequest } from '..';

export function get() {
  return getRequest(`/user-functions/`);
}